// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"383":"49d97380","922":"b8964a64"}[chunkId] + ".js";
};